import { Controller, useFormContext } from 'react-hook-form'

import { CheckBoxGroup, FF2 } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

import { suspiciousActivityInfoValidate } from '../../../../../hooks'

export const Cyber = () => {
  const { control } = useFormContext<SarEdit>()
  return (
    <Controller
      name="suspiciousActivityInfo.cyber"
      control={control}
      rules={{
        validate: suspiciousActivityInfoValidate
      }}
      render={({ field }) => (
        <FF2
          field={field}
          label="42. Cyber event"
          input={(props) => (
            <CheckBoxGroup
              {...props}
              data-qa={'42. Cyber event'}
              direction={'vertical'}
              data={[
                { label: 'a. Against Financial Institution(s)', value: 'a' },
                { label: 'b. Against Financial Institution Customer(s)', value: 'b' },
                { label: 'z. Other', value: 'z' }
              ]}
            />
          )}
        />
      )}
    />
  )
}
